import React, { useMemo, useRef, useState, useEffect } from "react";
import { TextField } from "@mui/material";

const StoreSearch = ({
  data = [],
  searchKey = "name",
  placeholder = "Search stores...",
  containerRef,
  targetRefs,
  onSelect,
  scrollOffset = 20,
}) => {
  const searchRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const searchResults = useMemo(() => {
    if (!searchQuery.trim()) return [];

    const query = searchQuery.toLowerCase().trim();

    return data.filter((item) => {
      const value = String(item[searchKey] || "")
        .toLowerCase()
        .trim();

      return value.includes(query);
    });
  }, [searchQuery, data, searchKey]);

  const handleScroll = (targetId) => {
    const container = containerRef?.current;
    const element = targetRefs?.current?.[targetId];

    if (!container || !element) return;

    const containerTop = container.getBoundingClientRect().top;

    const elementTop = element.getBoundingClientRect().top;

    const offset = elementTop - containerTop;

    container.scrollTo({
      top: container.scrollTop + offset - scrollOffset,
      behavior: "smooth",
    });
  };

  const handleSelect = (item) => {
    onSelect?.(item);

    setTimeout(() => {
      handleScroll(item.targetId);
    }, 200);

    setSearchQuery(item[searchKey]);
    setIsSearchOpen(false);
  };

  return (
    <div className="relative w-[400px]" ref={searchRef}>
      <TextField
        fullWidth
        size="small"
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => {
          setSearchQuery(e.target.value);
          setIsSearchOpen(true);
        }}
      />

      {isSearchOpen && searchQuery && (
        <div className="absolute top-[45px] left-0 w-full bg-white border rounded-lg shadow-lg z-50 max-h-[300px] overflow-y-auto">
          {searchResults.length > 0 ? (
            searchResults.map((item, index) => (
              <div
                key={`${item.targetId}-${item.storeName}-${index}`}
                className="p-3 hover:bg-gray-100 cursor-pointer border-b"
                onClick={() => handleSelect(item)}
              >
                <div className="font-medium text-sm">{item[searchKey]}</div>

                {item.subText && (
                  <div className="text-xs text-gray-500">{item.subText}</div>
                )}
              </div>
            ))
          ) : (
            <div className="p-3 text-sm text-gray-500">No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default StoreSearch;
